import { render, staticRenderFns } from "./HbIcon.vue?vue&type=template&id=1b5ee846&scoped=true&"
import script from "./HbIcon.vue?vue&type=script&lang=js&"
export * from "./HbIcon.vue?vue&type=script&lang=js&"
import style0 from "./HbIcon.vue?vue&type=style&index=0&id=1b5ee846&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5ee846",
  null
  
)

export default component.exports